import { useAccountsContext } from 'hooks/context/useAccountsContext'
import { EARN_MODEL, EarnModel } from '../types'

export const useEarnModel = (): EarnModel => {
  const { accountCapabilities } = useAccountsContext()

  const {
    isEmbeddedCustomerCompanyCapabilityEnabled,
    isEmbeddedCustomerIndividualCapabilityEnabled,
    paxosUsStatesCapability,
  } = accountCapabilities || {}

  const isEmbeddedPartner = Boolean(
    isEmbeddedCustomerCompanyCapabilityEnabled || isEmbeddedCustomerIndividualCapabilityEnabled
  )

  if (isEmbeddedPartner && paxosUsStatesCapability && paxosUsStatesCapability.length > 0) {
    return EARN_MODEL.EMBEDDED_PAXOS
  }

  if (isEmbeddedPartner) {
    return EARN_MODEL.EMBEDDED
  }

  return EARN_MODEL.DIRECT
}
